'use strict';

/**
 * Webduct Users (WebductUsers.js).
 * Webduct Users Helper.
 *
 * @author rsweeney@webduct.com <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @author Jenny Lam <jlam@buildcentrix.com>
 * @copyright (c) 2019-2021 Build Centrix
 *
 * @version
 * 2.22.0 LIBENV-147 Update permission check to support large numbers
 * 1.15.0 LIBENV-53 Add WebductUsers into globalThis for ES6 usage
 * 1.1.2 LIBENV-8 Fix Broken Resources
 * 1.0.0 LIBENV-1 Initialize environment library
 *
 */
var WebductUsers = function(cookieAdapter) {

    /**
     * Webduct Users
     *
     * This object is returned.
     *
     * @since 1.0.0
     *
     * @type {Object}
     */
    var helper = {};

    // Setting to true will set all permission checks to return true
    var debugFlag = false;

    // Webduct settings key (i.e. cookie key)
    var wdSettingsKey = 'wd.settings';

    /************************************ Old Functions (Deprecated) **************************************************/

    /**
     * Is Forced to Select An Existing Job Name/Number
     *
     * @since 1.0.0
     * @returns {Boolean}
     */
    helper.forceJobSelection = function () {
        return parseInt(getUserInfoByKey('forceJobSelection')) === 1;
    };

    /**
     * Get User Information
     *
     * @since 1.0.0
     * @return {Object}
     */
    helper.getInformation = function() {
        return getUserCookieInfo();
    };

    /**
     * Get USER Permissions
     *
     * @since 1.0.0
     * @return {Object}
     */
    helper.getPermissions = function() {
        return getUserPermissions();
    };

    /**
     * Get USER shop standards flag
     *
     * @since 1.0.0
     * @return {Number}
     */
    helper.getShopStandardsFlag = function() {
        return parseInt(getUserInfoByKey('shopStandards'));
    };

    /**
     * Get USER Ecommerce?
     *
     * @since 1.0.0
     * @return {Boolean}
     */
    helper.isEcommerce = function() {
        return parseInt(getUserInfoByKey('seatTypeIndex')) === 2;
    };

    /**
     * Is USER Internal?
     *
     * @since 1.0.0
     * @return {Boolean}
     */
    helper.isInternal = function() {
        return parseInt(getUserInfoByKey('seatTypeIndex')) === 1;
    };

    /**
     * User HAS PERMISSION of type
     *
     * @since 1.0.0
     * @param {Number} permission
     * @return {Boolean}
     */
    helper.hasPermission = function(permission) {
        return userHasPermission(permission);
    };

    /**
     * User HAS ROLE of type
     *
     * @since 1.0.0
     * @param {Number} role
     * @return {Boolean}
     */
    helper.hasRole = function(role) {
        return userHasRole(role);
    };

    /****************************************** Initialization ********************************************************/

    /**
     * Enable debugging mode (all permissions)
     *
     * @since 1.0.0
     * @returns {Boolean}
     */
    helper.setDebugMode = function(flag) {

        debugFlag = flag;

    };

    /***************************************** Private Functions ******************************************************/

    /**
     * Get USER Cookie Information
     *
     * @since 1.0.0
     * @return {Object}
     */
    function getUserCookieInfo() {

        var result = '';
        var cookieResult = cookieAdapter.getCookie(wdSettingsKey);

        if (typeof cookieResult !== 'undefined') {

            var cookieValue = JSON.parse(cookieResult);

            if (typeof cookieValue.user !== 'undefined') {

                result = cookieValue.user;

            }
        }

        return result;

    }

    /**
     * Get User Info By Key
     *
     * @since 1.0.0
     * @param {String} key
     * @return {String}
     */
    function getUserInfoByKey(key) {
        var userInfo = getUserCookieInfo();
        return userInfo[key];
    }

    /**
     * Get USER users
     *
     * @since 1.0.0
     * @return {Object}
     */
    function getUserPermissions() {
        var userInfo = getUserCookieInfo();
        return userInfo.permissions;
    }

    /**
     * User HAS ROLE of type
     *
     * @since 1.0.0
     * @param {Number} role
     * @return {Boolean}
     */
    function userHasRole(role) {

        var helperValue = getUserPermissions();

        var result = false;

        if (debugFlag === true) {
            result = true;
        } else {
            if (helperValue > 0) {   // if we have a user

                // the upper limit of 32 bit numbers
                var upperThreshold = Math.pow(2, 31) - 1;

                // check if the role value is greater than 32 bits
                if (role > upperThreshold) {
                    // Right shift the role and helperValue so that the values are both under 32 bits
                    // TODO: This is a temporary solution to deal with roles that have values that are larger than 32 bits
                    // This method will work until we reach permission values that are over 64 bits
                    // @see https://webduct.atlassian.net/browse/PLAT-859 for more information on the issue
                    var exponent = Math.floor(role / upperThreshold); // determine the number of times to right shift
                    role = role / Math.pow(2, exponent);
                    helperValue = helperValue / Math.pow(2, exponent);
                }

                /*jshint bitwise: false*/
                var userCheckResult = helperValue & role; // bitwise and operator on the requested role with the user's helper

                /* istanbul ignore else */
                if (userCheckResult > 0) {
                    result = true;
                }
            }
        }

        return result;

    }

    /**
     * User HAS PERMISSION of type
     *
     * @since 1.0.0
     * @param {Number} permission
     * @return {Boolean}
     */
    function userHasPermission(permission) {
        return userHasRole(permission);
    }

    return helper;

};
globalThis.WebductUsers = WebductUsers;
// EOF
